import { useWindowDimensions } from "../../context/window-dimensions-context/WindowDimensions";

export const useContentMargins = (
  contentMaxWidth = 2000,
  targetMargin = "1.5rem",
): [string, boolean] => {
  const { width: screenWidth, size } = useWindowDimensions();

  const isMobile = size === "small";
  if (isMobile) targetMargin = "1rem";

  const atContentMax = screenWidth >= contentMaxWidth;

  const maxWidthCompensation = `calc(${screenWidth}px - ${contentMaxWidth}px)`;
  const calculatedMargin = atContentMax
    ? `max(calc(${maxWidthCompensation} / 2), ${targetMargin})`
    : targetMargin;

  return [calculatedMargin, atContentMax];
};
